import { MDBBtn, MDBModalFooter } from 'mdb-react-ui-kit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { deleteRouingPlan } from '../../../apiclients/streamsapi_bridge';

function DeleteRoutingPlan(props) {
    const { t, i18n } = useTranslation();
    async function removeThisRouting(e) {
        e.preventDefault();
        console.log(props.props);
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let saverep = await deleteRouingPlan(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.deletePlanParam.agentid, props.deletePlanParam.dialplanid);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        if (saverepeMsg.status == "Failed") {
        } else {
            props.deletePlanId(props.deletePlanParam.dialplanid);
            props.setSuccessMessage(`Routing Plan ${props.deletePlanParam.name} removed successfully.`);
            props.setReloadPlan(true);
            props.setTwentyFourPlan(0);
            props.onClose();

        }
    }
    return (
        <>
            <div>
                <span className="">{t("removeroutingplan")}</span>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => {
                    e.preventDefault();
                    removeThisRouting(e);
                }}>{t("remove")}</MDBBtn>
            </MDBModalFooter>

        </>
    )
}

export default DeleteRoutingPlan;
